import React from 'react'
import { isWorldCup2026League } from '../constants/worldCup2026TeamFlags'
import { useTranslation } from '../hooks/use-i18n'
import TeamNameWithFlag from './TeamNameWithFlag'

interface VictoryTeamLabelProps {
  teamName: string
  league?: string | null
  side: 'home' | 'away'
  className?: string
  nameClassName?: string
  flagClassName?: string
}

const VictoryTeamLabel: React.FC<VictoryTeamLabelProps> = ({
  teamName,
  league,
  side,
  className = '',
  nameClassName = '',
  flagClassName = 'text-base leading-none flex-shrink-0',
}) => {
  const { t } = useTranslation()

  if (!isWorldCup2026League(league)) {
    return (
      <span className={className}>{t('predictions.victoryTeam', { team: teamName })}</span>
    )
  }

  const prefix = t('predictions.victoryTeam', { team: '' }).trimEnd()

  return (
    <span className={`inline-flex items-center justify-center gap-1.5 flex-wrap ${className}`}>
      {prefix ? <span>{prefix}</span> : null}
      <TeamNameWithFlag
        teamName={teamName}
        league={league}
        side={side}
        nameClassName={nameClassName}
        flagClassName={flagClassName}
      />
    </span>
  )
}

export default VictoryTeamLabel
